import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { MaterialUIControllerProvider } from "context";
import { Provider } from "react-redux";
import { store } from "./store";
import { setToken } from "slices/authSlice";
import { setAuth } from "slices/authSlice";

const container = document.getElementById("app");
const root = createRoot(container);

const token = localStorage.getItem("tokenf");
const adminUser = localStorage.getItem("adminUser");

if (token && adminUser) {
  store.dispatch(setToken(token));
  store.dispatch(setAuth(JSON.parse(adminUser)));
}

root.render(
  <Provider store={store}>
    <BrowserRouter >
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </Provider>
);
